<template>
    <span class="form-wrapper">
        <b-alert
            :show="!!serverErrors.non_field_errors"
            variant="danger"
            dismissible
        >
            <span v-for="err in serverErrors.non_field_errors">{{ err }}</span>
        </b-alert>

        <slot />

        <span v-if="formState.debug">
            {{ serverErrors }} <br />
            {{ v }}
        </span>
    </span>
</template>

<script>
// import {FIELD_TYPES} from "../../schema";
// import schema from "../../../app/schema";

export default {
    name: "OFormWrapper",
    model: {
        prop: "item",
        event: "changed",
    },
    props: {
        item: { type: Object, required: true },
        v: { type: Object, required: true },
        serverErrors: { type: Object, required: true },
        serverErrorsIndex: {
            type: Number,
            default: null,
        } /* If Null then server-errors is not an array */,
        formState: { type: Object, required: true },
        schema: { type: Object, required: true },
    },
    methods: {},
};
</script>

<style scoped></style>
